export const mandatoryFieldErrorMessage = {
    de: 'Pflichtfeld',
    fr: 'Champ obligatoire',
    it: 'Campo obbligatorio',
    en: 'Mandatory field',
};

export function minFieldErrorMessage(minValue: number) {
    return {
        de: `Der minimal zulässige Wert ist ${minValue}`,
        fr: `La valeur minimale autorisée est ${minValue}`,
        it: `Il valore minimo consentito è ${minValue}`,
        en: `The minimum allowed value is ${minValue}`,
    };
}

export function maxFieldErrorMessage(maxValue: number) {
    return {
        de: `Der maximal zulässige Wert ist ${maxValue}`,
        fr: `La valeur maximale autorisée est ${maxValue}`,
        it: `Il valore massimo consentito è ${maxValue}`,
        en: `The maximum allowed value is ${maxValue}`,
    };
}

export function tooManyCharsMessage(maxLength: number) {
    return {
        de: `Es sind nicht mehr als ${maxLength} Zeichen erlaubt für dieses Feld.`,
        fr: `Pas plus de ${maxLength} caractères sont autorisés pour ce champ.`,
        it: `Non sono consentiti più di ${maxLength} caratteri per questo campo.`,
        en: `No more than ${maxLength} characters are allowed for this field.`,
    };
}
